import React, { Component } from 'react';
import Table from '../components/Table'
import { getDatabaseDetails, getAllScenarioGroupNames } from '../components/UserFunctions'
import { addGroupToCart } from '../actions/addToCartAction'
import { connect } from "react-redux";
import Cart from '../components/CartComponent'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import ScenarioPopup from '../components/AddScenarioPopup'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class ViewScenario extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            group_name_list: [],
            scenario_group_name: "",
            scenario_popup: false,
        }
        this.openPopupModal = this.openPopupModal.bind(this)
        this.onhandleChangeGroupName = this.onhandleChangeGroupName.bind(this)
        this.handleOnChange = this.handleOnChange.bind(this)
        this.togglePopup = this.togglePopup.bind(this)
    }

    componentDidMount() {

        getDatabaseDetails().then(res => {
            this.setState(prevState => {
                return {
                    ...prevState,
                    data: res.data
                }
            })
        })

        const group_name_url = (window.location.origin).concat('/get_scenario_group_names')
        getAllScenarioGroupNames(group_name_url).then((response) => {
            if (response && response.status === 200) {
                this.setState({
                    group_name_list: response.data['data']
                })
            }
        })
    }

    togglePopup() {
        this.setState({
            scenario_popup: false,
        })
    }

    openPopupModal() {
        this.setState({
            scenario_popup: !this.state.scenario_popup
        })
    }

    onhandleChangeGroupName(e) {
        this.setState({
            scenario_group_name: e.target.value
        })
        let obj = {
            group: e.target.value,
        }
        this.props.dispatch(addGroupToCart(obj))
    }

    handleOnChange(event) {
        console.log(event.target.value)
    }

    render() {
        console.log(this.state.data)
        return (
            <div>
                <div className="container-fluid">
                    <Breadcrumb>
                        <Breadcrumb.Item href="">
                            <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <Link to='/welcome'>Welcome</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href=""  >
                            <Link to="/open_loop">Open loop</Link>
                            
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/view_scenario" active >
                            Scenario Selector

                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="row">
                        <div className="mt-5 mx-auto">
                            <div className="card" style={{ backgroundColor: "white" }}>
                                <div className="card">
                                    <div>
                                        <div style={{ backgroundColor: "#757AF7" }}>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h3 className="card-header" style={{ color: "white", fontSize: "100% !important", backgroundColor: "#757AF7" }}>
                                                        Scenario Selector
                                                    </h3>
                                                </div>
                                                <div className="col-md-4" style={{ textAlign: "center", paddingTop: "0.7%" }}>
                                                    <select id="inputState" className="form-control" value={this.state.scenario_group_name} onChange={(e) => this.onhandleChangeGroupName(e)}>
                                                        <option>Select Function</option>
                                                        <option>Highway</option>
                                                        <option>Urban</option>
                                                        <option>City</option>
                                                        <option>ACC</option>
                                                        <option>AEB</option>
                                                        <option>LKA</option>
                                                        <option>LCA</option>
                                                        <option>AES</option>
                                                        <option>ALC</option>
                                                        <option>TJA</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-4" style={{ paddingLeft: "15rem", paddingTop: "0.7%" }}>
                                                    <div style={{ textAlign: "center" }}>
                                                        <button onClick={this.openPopupModal} style={{ backgroundColor: "Transparent", outline: "None", border: "None", float: "right" }}><Cart /></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table col-md-6 mx-auto">
                                        <Table data={this.state.data} selected={this.state.scenario_group_name} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.scenario_popup ? <ScenarioPopup closePopup={this.togglePopup.bind(this)} useHistory={this.props} /> : undefined}
            </div>
        )
    }
}
ViewScenario.propTypes = {
    dispatch: PropTypes.string,
    //testRunStatus:PropTypes.string,
    //currentPage:PropTypes.string,
    //pages:PropTypes.string,
    //closeOnClick:PropTypes.string,
    //logoutOnClick:PropTypes.string,
}
ViewScenario.defaultProps = {
    dispatch: [],
    //testRunStatus:[],
    //currentPage:[],
    //pages:[],
    //closeOnClick:[],
    //logoutOnClick:[],
}
const mapStateToProps = (state) => {
    return {
        group: state.cartItems.group,
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };


export default connect(mapStateToProps)(ViewScenario)
